<template>
  <a-modal
    :title="formTitle || '新增空间'"
    v-model:visible="open"
    @cancel="onClose"
    :width="800"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="create-form-modal"
  >
    <!-- 表单内容 -->
    <a-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ flex: '0 0 150px' }"
      :wrapper-col="{ flex: '1 1 auto' }"
      class="two-column-form"
    >
      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 空间名称 -->
          <a-form-item label="空间名称" name="name">
            <a-input v-model:value="form.name" placeholder="请输入空间名称" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 所属大楼名 -->
          <a-form-item label="所属大楼名" name="buildingName">
            <a-input v-model:value="form.buildingName" placeholder="请输入所属大楼名" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 所属楼层 -->
          <a-form-item label="所属楼层" name="floorName">
            <a-input v-model:value="form.floorName" placeholder="请输入所属楼层" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- Level -->
          <a-form-item label="Level" name="level">
            <a-input v-model:value="form.level" placeholder="请输入level" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 空间性质 -->
          <a-form-item label="空间性质" name="spatialProperties">
            <a-select v-model:value="form.spatialProperties" placeholder="请选择空间性质" allow-clear>
              <a-select-option v-for="(d, index) in dict.type['spatial_properties']" :key="d.value" :value="d.value">{{ d.label }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 是否贴码 -->
          <a-form-item label="是否贴码" name="isLabeling">
            <a-select v-model:value="form.isLabeling" placeholder="请选择是否贴码" allow-clear>
              <a-select-option v-for="(d, index) in dict.type['sys_yes_no_number']" :key="Number(d.value)" :value="Number(d.value)">{{ d.label }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 服务职责 -->
          <a-form-item label="服务职责" name="serviceResponsibilities">
            <a-input v-model:value="form.serviceResponsibilities" placeholder="请输入服务职责" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 服务时长(分钟) -->
          <a-form-item label="服务时长(分钟)" name="serviceDuration">
            <a-input-number v-model:value="form.serviceDuration" placeholder="请输入服务时长(分钟)" :min="0" style="width: 100%" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 服务频次 -->
          <a-form-item label="服务频次" name="serviceFrequency">
            <a-input-number v-model:value="form.serviceFrequency" placeholder="请输入服务频次" :min="0" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 单次最低时长(分钟) -->
          <a-form-item label="单次最低时长(分钟)" name="minimumDuration">
            <a-input-number v-model:value="form.minimumDuration" placeholder="请输入单次最低时长(分钟)" :min="0" style="width: 100%" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- Corx -->
          <a-form-item label="corx" name="corx">
            <a-input v-model:value="form.corx" placeholder="请输入corx" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- Cory -->
          <a-form-item label="cory" name="cory">
            <a-input v-model:value="form.cory" placeholder="请输入cory" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 信标MAC码 -->
          <a-form-item label="信标MAC码:" name="beaconIds">
            <a-select
              v-model:value="form.beaconIds"
              mode="multiple"
              placeholder="请选择信标MAC码"
             
              style="width: 100%"
              :loading="beaconLoading"
              class="beacon-select-large beacon-select-left-align"
            >
              <a-select-option v-for="beacon in beaconList" :key="beacon.id" :value="beacon.id">
                {{ beacon.mac }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 操作按钮 -->
      <div class="bottom-control">
        <a-space>
          <a-button @click="cancel" class="cancel-btn"> 取消 </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm" class="save-btn">
            保存
          </a-button>
        </a-space>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
/**
 * 空间新增/编辑表单组件
 * 功能：提供空间的新增和编辑功能
 * - 新增时自动从Vuex获取项目ID
 * - 编辑时从后端获取空间详情
 * - 表单验证和提交
 */
import { getSpace, addSpace, updateSpace, listBeaconOptionsForSpace } from '@/api/system/space'

export default {
  name: 'CreateForm',
  dicts: ['spatial_properties', 'sys_yes_no_number'],
  data () {
    return {
      // 提交加载状态
      submitLoading: false,
      // 表单标题（添加/修改）
      formTitle: '',
      // 表单参数（只包含表单字段、id和projectId）
      form: {
        id: null,                          // 空间ID（编辑时使用）
        projectId: null,                   // 项目ID（从Vuex获取）
        name: null,                        // 空间名称
        buildingName: null,                // 所属大楼名
        floorName: null,                   // 所属楼层
        serviceResponsibilities: null,    // 服务职责
        serviceDuration: null,             // 服务时长（分钟）
        serviceFrequency: null,            // 服务频次
        minimumDuration: null,             // 单次最低时长（分钟）
        beaconIds: [],                     // 信标ID列表（多选）
        level: null,                      // Level
        spatialProperties: null,           // 空间性质（字典值）
        isLabeling: null,                  // 是否贴码（字典值）
        corx: null,                        // Corx
        cory: null                         // Cory
      },
      // 表单类型（1-新增，2-修改）
      formType: 1,
      // 抽屉显示/隐藏状态
      open: false,
      // 表单验证规则
      rules: {
        // 空间名称验证规则：必填
        name: [{ required: true, message: '空间名称不能为空', trigger: 'blur' }],
        // 空间性质验证规则：必填
        spatialProperties: [{ required: true, message: '空间性质不能为空', trigger: 'change' }],
        // 是否贴码验证规则：必填
        // isLabeling: [{ required: true, message: '是否贴码不能为空', trigger: 'change' }],
        // 服务职责验证规则：必填
        // serviceResponsibilities: [{ required: true, message: '服务职责不能为空', trigger: 'blur' }],
        // 服务时长(分钟)验证规则：必填
        serviceDuration: [{ required: true, type: 'number', message: '服务时长(分钟)不能为空', trigger: 'blur' }],
        // 服务频次验证规则：必填
        serviceFrequency: [{ required: true, type: 'number', message: '服务频次不能为空', trigger: 'blur' }],
        // 单次最低时长(分钟)验证规则：必填
        minimumDuration: [{ required: true, type: 'number', message: '单次最低时长(分钟)不能为空', trigger: 'blur' }],
      },
      // 信标列表（用于下拉选择）
      beaconList: [],
      // 信标加载状态
      beaconLoading: false
    }
  },
  methods: {
    /**
     * 关闭抽屉
     */
    onClose () {
      this.open = false
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },

    /**
     * 取消按钮操作
     * 关闭抽屉并重置表单
     */
    cancel () {
      this.open = false
      this.reset()
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },

    /**
     * 表单重置
     * 清空所有表单字段，重置为初始状态
     */
    reset () {
      this.formType = 1
      this.form = {
        id: null,                          // 空间ID
        projectId: null,                   // 项目ID
        name: null,                        // 空间名称
        buildingName: null,                // 所属大楼名
        floorName: null,                   // 所属楼层
        serviceResponsibilities: null,    // 服务职责
        serviceDuration: null,             // 服务时长
        serviceFrequency: null,            // 服务频次
        minimumDuration: null,             // 单次最低时长
        beaconIds: [],                     // 信标ID列表
        level: null,                      // Level
        spatialProperties: null,           // 空间性质
        isLabeling: null,                  // 是否贴码
        corx: null,                        // Corx
        cory: null                         // Cory
      }
      this.beaconList = []
    },

    /**
     * 新增按钮操作
     * 打开新增表单，从Vuex获取项目ID并设置到表单中
     * @param {Object} row - 行数据（未使用）
     */
    handleAdd (row) {
      // 从 Vuex 获取当前项目ID
      const currentProjectId = this.$store.getters.currentProjectId
      if (!currentProjectId) {
        this.$message.warning('请先选择项目', 3)
        return
      }
      // 重置表单
      this.reset()
      this.formType = 1
      // 设置项目ID
      this.form.projectId = currentProjectId
      // 加载信标列表（新增时 spaceId 为 null）
      this.loadBeaconList(currentProjectId, null)
      // 打开抽屉
      this.open = true
      this.formTitle = '添加'
    },

    /**
     * 修改按钮操作
     * 打开编辑表单，从后端获取空间详情并填充到表单中
     * @param {Object} row - 行数据对象（包含id）
     * @param {Number|String} ids - 空间ID（可选，如果row不存在则使用此值）
     */
    handleUpdate (row, ids) {
      // 重置表单
      this.reset()
      this.formType = 2
      // 获取空间ID
      const id = row ? row.id : ids
      // 从后端获取空间详情
      getSpace({ "id": id }).then(response => {
        this.form = response.data
        // 如果后端返回的是 beaconIds 数组，直接使用；否则需要从 beaconMac 或其他字段解析
        if (!this.form.beaconIds) {
          this.form.beaconIds = []
        }
        // 从 Vuex 获取当前项目ID（如果表单中没有）
        const currentProjectId = this.form.projectId || this.$store.getters.currentProjectId
        // 加载信标列表（编辑时传入 spaceId）
        this.loadBeaconList(currentProjectId, id)
        // 打开抽屉
        this.open = true
        this.formTitle = '修改'
      })
    },

    /**
     * 加载信标列表
     * 根据项目ID和空间ID查询可选择的信标列表
     * @param {Number|String} projectId - 项目ID
     * @param {Number|String} spaceId - 空间ID（编辑时传入，新增时为null）
     */
    loadBeaconList (projectId, spaceId) {
      if (!projectId) {
        this.beaconList = []
        return
      }
      this.beaconLoading = true
      listBeaconOptionsForSpace(projectId, spaceId).then(response => {
        if (response.code == 20001) {
          this.beaconList = response.data || []
        } else {
          this.beaconList = []
        }
      }).catch(() => {
        this.beaconList = []
        this.$message.error('获取信标列表失败，请稍后重试')
      }).finally(() => {
        this.beaconLoading = false
      })
    },

    /**
     * 提交表单
     * 根据表单类型（新增/修改）调用相应的API接口
     */
    submitForm () {
      this.$refs.form.validate().then(() => {
        this.submitLoading = true
        // 判断是修改还是新增
        if (this.form.id !== undefined && this.form.id !== null) {
          // 修改空间
          updateSpace(this.form).then(response => {
            this.$message.success('修改成功', 3)
            this.open = false
            // 触发ok事件，通知父组件刷新列表
            $emit(this, 'ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          // 新增空间
          addSpace(this.form).then(response => {
            this.$message.success('新增成功', 3)
            this.open = false
            // 触发ok事件，通知父组件刷新列表
            $emit(this, 'ok')
          }).finally(() => {
            this.submitLoading = false
          })
        }
      }).catch(() => {
        // 验证失败
        return false
      })
    }
  },
  emits: ['ok', 'close'],
}
</script>

<style scoped>
/* 按钮样式 */
.save-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.save-btn:hover {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  opacity: 0.9;
}

.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}

.bottom-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}
</style>

<style>
/* Modal body 样式 - 使用全局样式确保生效 */
.create-form-modal .ant-modal-body {
  padding: 20px 16px 70px 4px !important;
}

/* 表单左边距调整 - 使用全局样式 */
.create-form-modal .ant-form {
  margin-left: -24px !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>

<style>
/* 输入框样式 - 圆角和边框 */
.create-form-modal .ant-input,
.create-form-modal .ant-input:hover,
.create-form-modal .ant-input:focus {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.create-form-modal .ant-input-affix-wrapper,
.create-form-modal .ant-input-affix-wrapper:hover,
.create-form-modal .ant-input-affix-wrapper-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.create-form-modal .ant-input-affix-wrapper .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 选择框样式 */
.create-form-modal .ant-select-selector,
.create-form-modal .ant-select-selector:hover,
.create-form-modal .ant-select-focused .ant-select-selector {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 信标MAC码选择框高度增加1.5倍，每个标签单独一行，完全左对齐 */
:deep(.create-form-modal .beacon-select-large .ant-select-selector) {
  min-height: 48px !important;
  height: auto !important;
  padding: 4px 11px 4px 0 !important;
  padding-left: 0 !important;
}

:deep(.create-form-modal .beacon-select-large .ant-select-selection-overflow) {
  min-height: 40px !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  padding-top: 4px !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-left: 0 !important;
  flex-wrap: wrap !important;
  display: flex !important;
  flex-direction: column !important;
  width: 100% !important;
}

:deep(.create-form-modal .beacon-select-large .ant-select-selection-item) {
  margin-top: 2px !important;
  margin-bottom: 2px !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 20px !important;
  width: 100% !important;
  max-width: 100% !important;
  flex: 0 0 auto !important;
  text-align: left !important;
  justify-content: flex-start !important;
  display: flex !important;
  align-items: center !important;
  position: relative !important;
}

:deep(.create-form-modal .beacon-select-large .ant-select-selection-item-content) {
  text-align: left !important;
  flex: 1 !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
  display: inline-block !important;
}

:deep(.create-form-modal .beacon-select-large .ant-select-selection-item-remove) {
  position: absolute !important;
  right: 4px !important;
  margin-left: auto !important;
}

/* 日期选择器样式 */
.create-form-modal .ant-picker,
.create-form-modal .ant-picker:hover,
.create-form-modal .ant-picker-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 数字输入框样式 */
.create-form-modal .ant-input-number,
.create-form-modal .ant-input-number:hover,
.create-form-modal .ant-input-number-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 按钮保持圆角 */
.create-form-modal .ant-btn {
  border-radius: 4px !important;
}

/* 两列布局样式 */
.two-column-form :deep(.ant-form-item-control-wrapper) {
  flex: 1;
}

.two-column-form :deep(.ant-row) {
  flex-wrap: nowrap;
}

.two-column-form :deep(.ant-col-12) {
  width: 50%;
  max-width: 50%;
}

/* 减少列之间的间距 */
.two-column-form :deep(.ant-col-12:first-child) {
  padding-right: 6px !important;
}

.two-column-form :deep(.ant-col-12:last-child) {
  padding-left: 6px !important;
}

/* 减少整个表单的左边距 */
.two-column-form :deep(.ant-form-item) {
  margin-left: -8px !important;
  margin-right: -8px !important;
}

/* 调整标签对齐，确保不会过于靠右 */
.two-column-form :deep(.ant-form-item-label) {
  margin-right: -4px !important;
}
</style>

<style>
/* 信标MAC码选择框 - 强制左对齐 */
.beacon-select-large .ant-select-selector {
  min-height: 48px !important;
  height: auto !important;
  padding: 4px 11px 4px 0 !important;
}

.beacon-select-large .ant-select-selection-overflow {
  min-height: 40px !important;
  padding-top: 4px !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-left: 0 !important;
  flex-wrap: wrap !important;
  display: flex !important;
  flex-direction: column !important;
  width: 100% !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
}

/* ant-select-selection-overflow-item 宽度一致，文字左对齐 */
.beacon-select-large .ant-select-selection-overflow-item {
  width: 100% !important;
  max-width: 100% !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  text-align: left !important;
}

.beacon-select-large .ant-select-selection-item {
  margin-top: 2px !important;
  margin-bottom: 2px !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 20px !important;
  width: 100% !important;
  max-width: 100% !important;
  flex: 0 0 auto !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  position: relative !important;
}

.beacon-select-large .ant-select-selection-item-content {
  margin-left: 0 !important;
  padding-left: 0 !important;
  text-align: left !important;
  flex: 0 1 auto !important;
}

.beacon-select-large .ant-select-selection-item-remove {
  position: absolute !important;
  right: 4px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}

/* 覆盖所有可能的样式 */
.ant-select-multiple.beacon-select-large .ant-select-selector {
  padding-left: 0 !important;
}

.ant-select-multiple.beacon-select-large .ant-select-selection-overflow {
  padding-left: 0 !important;
  margin-left: 0 !important;
  padding-inline-start: 0 !important;
  margin-inline-start: 0 !important;
}

.ant-select-multiple.beacon-select-large .ant-select-selection-overflow-item {
  width: 100% !important;
  max-width: 100% !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
  margin-inline-start: 0 !important;
  padding-inline-start: 0 !important;
  text-align: left !important;
}

.ant-select-multiple.beacon-select-large .ant-select-selection-item {
  margin-left: 0 !important;
  padding-left: 0 !important;
  margin-inline-start: 0 !important;
  padding-inline-start: 0 !important;
}
</style>
